import { render, staticRenderFns } from "./MessageSection.vue?vue&type=template&id=d7eda8fc&scoped=true&"
import script from "./MessageSection.vue?vue&type=script&lang=ts&"
export * from "./MessageSection.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSection.vue?vue&type=style&index=0&id=d7eda8fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7eda8fc",
  null
  
)

export default component.exports